export default __webpack_public_path__ + "static/media/neuralmetrics_capital_logo.b589a3c7.svg";